import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-s-bold relative flex h-[50px] cursor-pointer items-center justify-center border-1 border-transparent px-7 whitespace-nowrap uppercase transition',
    loading: 'loading absolute transition-opacity',
    children: 'flex-center relative transition-opacity'
  },
  variants: {
    color: {
      default: 'bg-blue-dark text-white',
      primary: 'text-main bg-yellow-naos',
      secondary: 'bg-blue-light text-black',
      white: 'bg-white text-black',
      outlined: 'border-white bg-transparent text-white',
      ghost: 'hover: bg-transparent'
    },
    loading: {
      true: {
        base: 'cursor-default',
        loading: 'opacity-100',
        children: 'opacity-0'
      },
      false: {
        loading: 'opacity-0',
        children: 'opacity-100'
      }
    },
    disabled: {
      true: {
        base: 'cursor-default'
      }
    },
    rounded: {
      full: {
        base: 'rounded-full'
      }
    }
  },
  compoundVariants: [
    {
      loading: false,
      disabled: false,
      color: 'default',
      class: 'hover:bg-blue'
    },
    {
      loading: false,
      disabled: false,
      color: 'primary',
      class: 'hover:bg-main hover:text-white'
    },
    {
      loading: false,
      disabled: false,
      color: 'secondary',
      class: 'hover:border-blue hover:bg-white'
    },
    {
      loading: false,
      disabled: false,
      color: 'outlined',
      class: 'hover:border-gray-300 hover:text-gray-300'
    },
    {
      loading: false,
      disabled: false,
      color: 'ghost',
      class: 'hover:text-blue'
    },
    {
      disabled: true,
      color: ['default', 'primary'],
      class: 'bg-[#E3E6E7] text-gray-500'
    },
    {
      disabled: true,
      color: ['secondary', 'outlined'],
      class: 'border-1 border-gray-500 bg-white text-gray-500'
    }
  ],
  defaultVariants: {
    size: 'base',
    color: 'default',
    loading: false,
    disabled: false
  }
});
